import { Plugin } from 'vue';
import Comment from './comment';
import Editor from './editor';
import Fold from './fold';
import Icon from './icon';
import Emoji from './emoji';

export default [Comment, Editor, Fold, Icon, Emoji] as Plugin[];
